module.exports = __webpack_public_path__ + "static/img/2213_phase_function_Paper_Points.0316acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2213_phase_function_Paper_Points.png
// module id = uLF8
// module chunks = 0